import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UiArguments } from "@recore-solutions/nstar-lib";
import { of } from "rxjs";
import { CodeTableService } from "src/app/listing/code-table.service";
import { ListingService } from "./listing.service";
import { LoonFnFactoriesService } from "./loon-fn-factories.service";

@Injectable({ providedIn: "root" })
export class SchoolFnFactoriesService extends LoonFnFactoriesService {
	constructor(
		protected listingService: ListingService,
		protected codeTableService?: CodeTableService
	) {
		super(listingService, codeTableService);
	}

	queryTransformFn = (uiArguments: UiArguments) => {
		return (term: any, additionalParams: any[]) => {
			if (!!term && typeof term === "number") {
				return new HttpParams({
					fromObject: {
						[uiArguments.uiComponent.databaseTable + "." + uiArguments.uiComponent.databaseColumn]:
							(term as number).toString(),
					},
				});
			} else {
				if (!additionalParams?.every((a) => !!a)) {
					return null;
				}
				const children = uiArguments.uiComponents.filter(
					(u) =>
						u.parentApplicationUIComponentSK === uiArguments.uiComponent.applicationUIComponentSK
				);
				let httpParams = new HttpParams();
				httpParams = children.reduce(
					(a, c, i) =>
						!Array.isArray(additionalParams[i])
							? a.set(
									c.databaseTable + "." + c.databaseColumn,
									additionalParams[i]?.key ? additionalParams[i].key : additionalParams[i]
							  )
							: a,
					httpParams
				);
				return httpParams;
			}
		};
	};

	searchFn = () => (httpParams: HttpParams) => {
		if (!httpParams) {
			return of([]);
		}
		return this.listingService.getGenericProcValues("Polaris.spGetSchoolAPI", httpParams);
	};

	resultTransformFn = () => {
		return (results: any[]) => {
			const typeName = {
				ELEM: "Elementary",
				MDDL: "Middle",
				HIGH: "High",
			};
			const schoolNameBuilder = (s: any) => {
				return s.schoolName
					? s.schoolName + (s.schoolTypeCD ? " (" + typeName[s.schoolTypeCD] + ")" : "")
					: s.schoolDistrictFullName;
			};
			return results
				.map((r) => ({
					...r,
					schoolName: schoolNameBuilder(r),
					sortOrder: r.schoolTypeCD === "ELEM" ? 0 : r.schoolTypeCD === "MDDL" ? 1 : 2,
				}))
				.sort((a, b) => a.schoolDistrictNumber - b.schoolDistrictNumber)
				.sort((a, b) => a.sortOrder - b.sortOrder);
		};
	};
}
